/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-04-08 11:39:10
 *
 *******************************************************/
// @flow
import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Banner, Button, TextStyle, TextField, Icon, Grid, Badge, Link } from '@shopify/polaris';
import { DuplicateMinor, CircleTickMajor } from '@shopify/polaris-icons';

import EnableBoostCoreSSR from 'src/assets/images/recommendation/enable-boost-core-ssr.png';
import CreateBoostAppFile from 'src/assets/images/recommendation/create-boost-app-file.gif';
import AddRecommendationToPage from 'src/assets/images/recommendation/add-recommendation-to-page.gif';

import { showSABToast } from 'src/integrations/shopify-app-bridge/toast';

//------------------StoreV1SSRTab----------------------

const manualCode = `{% comment %} PLEASE DO NOT EDIT THIS FILE {% endcomment %}
{% case type %}
  {% when 'product-filter' %}
    <div class="boost-sd__filter-product-list"></div>
    <script>
      if (window.boostSDTaeUtils && window.boostSDTaeUtils.initCollectionFilter) 
      {window.boostSDTaeUtils.initCollectionFilter();}
    </script>
  {% when 'recommendation' %}
    <div id="boost-sd-widget-{{- widgetId -}}"></div>
{% endcase %}`;
const widgetCode = `{% render 'boost-sd-app', type: 'recommendation', widgetId: 'Replace widgetId here' %}`;

const StoreV1SSRTab = props => {
  const {
    i18n,
    handleOpenBoostCore,
    handleOpenBoostCoreSSR,
    enabledBoostCore,
    handleOpenEditCode,
    templateId
  } = props;
  // copy clip board
  const copyClipBoard = (copyText: string) => {
    try {
      const inputText = document.createElement('input');
      inputText.value = copyText;
      document.body.appendChild(inputText);
      inputText.select();

      document.execCommand('copy');
      document.body.removeChild(inputText);
      showSABToast(i18n.translate('AdminHTML.Common.Action.copied', { t: copyText }), false);
    } catch (error) {}
  };

  return (
    <div className="online-store-v1">
      <div className="step-guide step01">
        <Grid>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
            <div className="content">
              <div>
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Label'
                  )}
                </TextStyle>
                <span style={{ marginLeft: '0.375rem' }}>
                  <Badge status="attention">
                    {i18n.translate('AdminHTML.Recommendation.Common.required')}
                  </Badge>
                </span>
              </div>
              <div>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content_t1'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </div>
              {enabledBoostCore ? (
                <p>
                  <Icon source={CircleTickMajor} color="success" />
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetStepsGuideInstall.enableBoostCore'
                  )}
                </p>
              ) : (
                <>
                  <Button onClick={handleOpenBoostCoreSSR} primary>
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Action'
                    )}
                  </Button>
                  <div>
                    {i18n.translate(
                      'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02',
                      {
                        t1: (
                          <TextStyle variation="strong">
                            {i18n.translate(
                              'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_t1'
                            )}
                          </TextStyle>
                        )
                      }
                    )}
                    <ul style={{ marginTop: 0, paddingLeft: '1.25rem' }}>
                      <li>
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_Line01',
                          {
                            t1: (
                              <TextStyle variation="strong">
                                {i18n.translate(
                                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_Line01_t1'
                                )}
                              </TextStyle>
                            ),
                            t2: (
                              <TextStyle variation="strong">
                                {i18n.translate(
                                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_Line01_t2'
                                )}
                              </TextStyle>
                            ),
                            t3: (
                              <Link onClick={handleOpenBoostCore}>
                                {i18n.translate(
                                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_Line01_t3'
                                )}
                              </Link>
                            )
                          }
                        )}
                      </li>
                      <li>
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_Line02',
                          {
                            t1: (
                              <TextStyle variation="strong">
                                {i18n.translate(
                                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_Line02_t1'
                                )}
                              </TextStyle>
                            )
                          }
                        )}
                      </li>
                      <li>
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step01_Content02_Line03'
                        )}
                      </li>
                    </ul>
                    <div className="html-placeholder">
                      <TextField
                        name="templateId"
                        id="templateId"
                        value={templateId}
                        disabled="disabled"
                        suffix={
                          <Button
                            icon={DuplicateMinor}
                            plain
                            onClick={() => copyClipBoard(templateId)}
                          />
                        }
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
            <div className="video">
              <img
                className="clickable"
                src={EnableBoostCoreSSR}
                alt="enable-boost-core"
                style={{ width: '100%' }}
                onClick={() => window.open(EnableBoostCoreSSR, '_blank', 'noopener,noreferrer')}
              />
            </div>
          </Grid.Cell>
        </Grid>
      </div>
      <div className="step-guide step02">
        <Grid>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
            <div className="content">
              <TextStyle variation="strong">
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step02_Label'
                )}
              </TextStyle>
              <div>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step02_Content',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step02_Content_t1'
                        )}
                      </TextStyle>
                    ),
                    nt1: (
                      <TextStyle variation="negative">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step02_Content_nt1'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </div>
              <Button onClick={handleOpenEditCode}>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step02_Action'
                )}
              </Button>
            </div>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
            <div className="video">
              <img
                className="clickable"
                alt="gif-create-boost-app-file"
                src={CreateBoostAppFile}
                style={{ width: '100%', border: '0.88px solid #e1e3e5' }}
                onClick={() => window.open(CreateBoostAppFile, '_blank', 'noopener,noreferrer')}
              />
            </div>
          </Grid.Cell>
        </Grid>
        <div className="content">
          <div className="html-placeholder">
            <TextField
              name="manualCode"
              id="manualCode"
              value={manualCode}
              multiline={11}
              disabled="disabled"
              suffix={
                <Button icon={DuplicateMinor} plain onClick={() => copyClipBoard(manualCode)} />
              }
            />
          </div>
        </div>
      </div>
      <div className="step-guide step03">
        <Grid>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
            <div className="content">
              <TextStyle variation="strong">
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step03_Label'
                )}
              </TextStyle>
              <div>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step03_Content',
                  {
                    t1: (
                      <TextStyle variation="strong">
                        {i18n.translate(
                          'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step03_Content_t1'
                        )}
                      </TextStyle>
                    )
                  }
                )}
              </div>
              <table>
                <thead>
                  <tr>
                    <th>
                      {i18n.translate(
                        'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step03_Table_Header1'
                      )}
                    </th>
                    <th>
                      {i18n.translate(
                        'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step03_Table_Header2'
                      )}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4].map(i => (
                    <tr key={i}>
                      {[1, 2].map(j => (
                        <td key={j}>
                          {i18n.translate(
                            `AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step03_Table_Row${i}_Col${j}`
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>

              <Button onClick={handleOpenEditCode}>
                {i18n.translate(
                  'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.step03_Action'
                )}
              </Button>
            </div>
          </Grid.Cell>
          <Grid.Cell columnSpan={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
            <div className="video">
              <img
                className="clickable"
                alt="gif-add-recommendation-to-your-page"
                src={AddRecommendationToPage}
                style={{ width: '100%', border: '0.88px solid #e1e3e5' }}
                onClick={() =>
                  window.open(AddRecommendationToPage, '_blank', 'noopener,noreferrer')
                }
              />
            </div>
          </Grid.Cell>
        </Grid>
        <div className="content">
          <div className="html-placeholder">
            <TextField
              name="widgetCode"
              id="widgetCode"
              value={widgetCode}
              disabled="disabled"
              suffix={
                <Button icon={DuplicateMinor} plain onClick={() => copyClipBoard(widgetCode)} />
              }
            />
          </div>
        </div>
      </div>

      <Banner status="info">
        <p>
          {i18n.translate(
            'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.blockContent01'
          )}
        </p>
        <p>
          {i18n.translate(
            'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.blockContent02',
            {
              t1: (
                <TextStyle variation="strong">
                  {i18n.translate(
                    'AdminHTML.Recommendation.WidgetStepsGuideInstall.tab01SSR.blockContent02_t1'
                  )}
                </TextStyle>
              )
            }
          )}
        </p>
      </Banner>
    </div>
  );
};
export default withI18n()(StoreV1SSRTab);
